
(function() {
  var result = { translations: { "bg": { "i18n": { "duration": { "seconds": "{{ seconds }} \u0441\u0435\u043A", "minutes": "{{ minutes }} \u043C\u0438\u043D", "hours": "{{ hours }} \u0447", "hoursAndMinutes": "{{ hours }} \u0447 {{ minutes }} \u043C\u0438\u043D", "days": "{{ days }} \u0434\u043D\u0438", "shortForm": { "seconds": "{{ seconds }} \u0441\u0435\u043A", "minutes": "{{ minutes }} \u043C\u0438\u043D", "hours": "{{ hours }} \u0447", "days": "{{ days }} \u0434", "hoursAndMinutes": "{{ hours }} \u0447 {{ minutes }} \u043C\u0438\u043D" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, \u0432\u044A\u0442\u0440. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "bg": "static-7.1127"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1127",
    "ar-eg": "static-7.1127",
    "bg": "static-7.1127",
    "bn": "static-7.1127",
    "ca-es": "static-7.1127",
    "cs": "static-7.1127",
    "da": "static-7.1127",
    "de": "static-7.1127",
    "el": "static-7.1127",
    "en-gb": "static-7.1127",
    "en": "static-7.1127",
    "es-mx": "static-7.1127",
    "es": "static-7.1127",
    "et": "static-7.1127",
    "fi": "static-7.1127",
    "fr-ca": "static-7.1127",
    "fr": "static-7.1127",
    "he-il": "static-7.1127",
    "hi": "static-7.1127",
    "hr": "static-7.1127",
    "hu": "static-7.1127",
    "id": "static-7.1127",
    "it": "static-7.1127",
    "ja": "static-7.1127",
    "ko": "static-7.1127",
    "lt": "static-7.1127",
    "ms": "static-7.1127",
    "nl": "static-7.1127",
    "no": "static-7.1127",
    "pl": "static-7.1127",
    "pt-br": "static-7.1127",
    "pt-pt": "static-7.1127",
    "ro": "static-7.1127",
    "ru": "static-7.1127",
    "sk": "static-7.1127",
    "sl": "static-7.1127",
    "sv": "static-7.1127",
    "th": "static-7.1127",
    "tl": "static-7.1127",
    "tr": "static-7.1127",
    "uk": "static-7.1127",
    "vi": "static-7.1127",
    "x-pseudo": "static-7.1127",
    "zh-cn": "static-7.1127",
    "zh-hk": "static-7.1127",
    "zh-tw": "static-7.1127"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:bg', {version: 'static-7.1127'}); }
})();


